import { EmailAttachedTag } from '../../Email'
import { EntityTag } from '../../Entity'
import { EntityExtraTagsItem } from '../../EntityExtraTags'
import { FileAttachTag } from '../../File'
import { RequestAttachTag } from '../../Request'
import { Status } from '../../Status'
import { Tag, TAG_APPEARANCE, TAG_HEIGHT } from '../../Tag'
import { UserTag } from '../../User'
import { Container } from '../Container'

import * as styles from './Tags.module.css'

import EmailIcon from '../../../icons/email.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
import TaskIcon from '../../../icons/task.svg'

const errorStatus = (
  <Status
    backgroundColor='var(--color-error-10)'
    text='Error'
    textColor='var(--color-error)'
  />
)

const progressStatus = (
  <Status
    backgroundColor='var(--color-in-progress-10)'
    text='In progress'
    textColor='var(--color-in-progress)'
  />
)

const emailDemoItem = {
  last_message: {
    created: '2021-01-22T10:30:00Z',
    outgoing: false,
    owner_obj: {
      avatar: { color: 'var(--color-chart-4)' },
      email: 'monica.becker@example.com',
      id: 1,
      name: 'Monica Becker',
    },
    recipients: [],
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  },
  title: 'Annual maintenance check scheduled for next month',
  unread: false,
  uuid: 'tag-email-demo',
}

const emailDemoItemMulti = {
  last_message: {
    created: '2021-01-22T10:30:00Z',
    outgoing: true,
    owner_obj: {
      avatar: { color: 'var(--color-chart-1)' },
      email: 'me@example.com',
      id: 1,
      name: 'Me',
    },
    recipients: [
      {
        avatar: { color: 'var(--color-chart-4)' },
        email: 'monica.becker@example.com',
        id: 2,
        name: 'Monica Becker',
      },
      {
        avatar: { color: 'var(--color-chart-2)' },
        email: 'denton@example.com',
        id: 3,
        name: 'Denton Stevenson',
      },
    ],
    text: 'Thanks for the report — I will review and get back to you with our action plan by end of week',
  },
  title: 'Re: Roof inspection report findings',
  unread: true,
  uuid: 'tag-email-demo-multi',
}

function Tags() {
  return (
    <>
      <Container label='EntityExtraTagsItem, with counts and icon'>
        <EntityExtraTagsItem
          Icon={EmailIcon}
          count={5}
          errorCount={1}
          newCount={3}
          text='Emails'
          tooltip={
            <div className={styles.tooltipContent}>
              <span>All emails (5)</span>
              <span>Unread emails (3)</span>
              <span>Error emails (1)</span>
            </div>
          }
        />
      </Container>
      <Container label='Request Attach Tag'>
        <RequestAttachTag
          item={{
            request_no: '1',
            status: 1,
            title: 'request',
          }}
        />
      </Container>

      <Container label='Tag filled, default, height 20'>
        <Tag
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height20}
          text='Label'
        />
      </Container>
      <Container label='Tag filled, default, long text, height 20'>
        <Tag
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height20}
          text='Tag Tag Tag Tag Tag Tag Tag Tag Tag'
        />
      </Container>
      <Container label='Tag filled, removable, height 20'>
        <Tag
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height20}
          text='Removable tag'
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag filled, removable, error, height 20'>
        <Tag
          isError
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height20}
          text='Removable tag'
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag filled, removable, loading, height 20'>
        <Tag
          isLoading
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height20}
          text='Removable tag'
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag filled, two values, short, height 20'>
        <Tag
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height20}
          secondText='No. 19b'
          text='Ortliebgasse 31'
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag filled, two values, first long, height 20'>
        <Tag
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height20}
          secondText='No. 22a'
          text='Ortliebgasse 31, 1170 Vienna'
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag filled, two values, both long, height 20'>
        <Tag
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height20}
          secondText='No. 22a lorem ipsum'
          text='Ortliebgasse 31, 1170 Vienna'
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag filled, disabled, height 20'>
        <Tag
          isDisabled
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height20}
          text='Disabled tag'
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag filled, removable, height 24'>
        <Tag
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height24}
          text='Label 24px'
          onRemove={() => {}}
        />
      </Container>

      <Container label='Tag filled, height 32 (orthogonal axes)'>
        <Tag
          appearance={TAG_APPEARANCE.filled}
          height={TAG_HEIGHT.height32}
          text='Filled 32'
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag outlined, height 24 (orthogonal axes)'>
        <Tag
          appearance={TAG_APPEARANCE.outlined}
          height={TAG_HEIGHT.height24}
          text='Outlined 24'
          onRemove={() => {}}
        />
      </Container>

      <Container label='Tag Default, height 28'>
        <Tag height={TAG_HEIGHT.height28} text='0192875-doc.pdf' />
      </Container>
      <Container label='Tag Default, height 32'>
        <Tag text='0192875-doc.pdf' />
      </Container>
      <Container label='Tag Default, with status, height 32'>
        <Tag meta={errorStatus} text='0192875-doc.pdf' />
      </Container>
      <Container label='Tag Default, loading + delete, height 32'>
        <Tag isLoading text='0192875-doc.pdf' onRemove={() => {}} />
      </Container>
      <Container label='Tag Default, skeleton, height 40'>
        <Tag isSkeleton height={TAG_HEIGHT.height40} text='' />
      </Container>
      <Container label='Tag Default, disabled, height 32'>
        <Tag isDisabled meta={errorStatus} text='0192875-doc.pdf' />
      </Container>

      <Container label='Tag Entity (service request), height 32'>
        <EntityTag
          avatarProps={{ Icon: ServiceRequestIcon }}
          meta={progressStatus}
          name='0123 Roof Replacement'
        />
      </Container>
      <Container label='Tag Entity (task), height 40'>
        <EntityTag
          avatarProps={{ Icon: TaskIcon }}
          height={TAG_HEIGHT.height40}
          meta={progressStatus}
          name='Inspect roof damage'
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag Entity (task) raw Icon, height 40'>
        <EntityTag
          Icon={TaskIcon}
          height={TAG_HEIGHT.height40}
          meta={progressStatus}
          name='Inspect roof damage'
          onRemove={() => {}}
        />
      </Container>

      <Container label='Tag User, with initials, height 32'>
        <UserTag
          avatarColor='var(--color-chart-1)'
          meta={errorStatus}
          name='Denton Stevenson'
        />
      </Container>
      <Container label='Tag User, with delete, height 40'>
        <UserTag
          avatarColor='var(--color-chart-2)'
          height={TAG_HEIGHT.height40}
          name='Monica Becker'
          onRemove={() => {}}
        />
      </Container>

      <Container label='EmailAttachedTag, with status, height 32'>
        <EmailAttachedTag item={emailDemoItem} meta={errorStatus} />
      </Container>
      <Container label='EmailAttachedTag, with delete, height 40'>
        <EmailAttachedTag
          height={TAG_HEIGHT.height40}
          item={emailDemoItem}
          onDelete={() => {}}
        />
      </Container>
      <Container label='EmailAttachedTag, multiple recipients, height 32'>
        <EmailAttachedTag item={emailDemoItemMulti} onDelete={() => {}} />
      </Container>
      <Container label='EmailAttachedTag, disabled, height 32'>
        <EmailAttachedTag disabled item={emailDemoItem} onDelete={() => {}} />
      </Container>

      <Container label='Tag File (PDF), height 32'>
        <FileAttachTag file={{ name: '0192875-contract.pdf' }} fileType='pdf' />
      </Container>
      <Container label='Tag File (PDF), with size, height 32'>
        <FileAttachTag
          file={{ name: '0192875-contract.pdf', size: 245678 }}
          fileType='pdf'
        />
      </Container>
      <Container label='Tag File (PDF), with status, height 32'>
        <FileAttachTag
          file={{ name: '0192875-contract.pdf' }}
          fileType='pdf'
          meta={errorStatus}
        />
      </Container>
      <Container label='Tag File (PDF), with error tooltip, height 32'>
        <FileAttachTag
          file={{
            error: { text: 'File too large to upload.' },
            name: '0192875-contract.pdf',
          }}
          fileType='pdf'
        />
      </Container>
      <Container label='Tag File (doc), with delete, height 40'>
        <FileAttachTag
          file={{ name: 'specification.docx' }}
          fileType='doc'
          height={TAG_HEIGHT.height40}
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag File (link), with delete, height 40'>
        <FileAttachTag
          file={{
            link: 'https://example.com/specification.docx',
            name: 'specification.docx',
          }}
          fileType='doc'
          height={TAG_HEIGHT.height40}
          onRemove={() => {}}
        />
      </Container>
      <Container label='Tag File (link, error), with delete, height 40'>
        <FileAttachTag
          file={{
            error: { text: 'File too large to upload.' },
            link: 'https://example.com/specification.docx',
            name: 'specification.docx',
            size: 3456789,
          }}
          fileType='doc'
          height={TAG_HEIGHT.height40}
          onRemove={() => {}}
        />
      </Container>
    </>
  )
}

export default Tags
